import { useClearedQueryParamValue } from 'src/app/shared/hooks/location';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

export function useShowSignForm(): boolean {
	const isMobile = useIsMobile();
	return useClearedQueryParamValue('show_sign') === 'true' && isMobile;
}
